import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils';

/**
 * Converts a geometry from Web Mercator units (wkid: 3857) to geographic units (wkid: 4326).
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-support-webMercatorUtils.html#webMercatorToGeographic
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-Geometry.html
 * https://community.esri.com/t5/arcgis-javascript-maps-sdk-questions/how-to-convert-polygon-vertex-to-lat-lon/td-p/1221798
 * @param {Object} geometry - The geometry object, i.e., graphics drawn from the sketch widget.
 */
export const webMercatorToGeographic = async geometry =>
  await handleWebMercatorToGeographic(geometry);

const handleWebMercatorToGeographic = geometry =>
  webMercatorUtils.webMercatorToGeographic(geometry);
